import styled from 'styled-components';

import Text from '@polyai/ui/components/atoms/Text';
import themeColors from '@polyai/ui/styles/config/colors';
import themeSpacing from '@polyai/ui/styles/config/spacing';

export const Wrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;

  height: 100%;
  padding: ${themeSpacing.sm1} ${themeSpacing.sm3} ${themeSpacing.sm3}
    ${themeSpacing.sm3};
`;

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${themeSpacing.xs2};
  align-items: flex-start;
  align-self: stretch;

  padding: ${themeSpacing.sm3};
`;

export const HeaderWrapper = styled.div`
  display: flex;
  gap: ${themeSpacing.sm1};
  align-items: center;
  align-self: stretch;
`;

export const FormContent = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: ${themeSpacing.sm3};

  min-height: 0;
`;

export const FormWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  height: 100%;

  form {
    display: flex;
    flex: 1;
    flex-direction: column;
    height: 100%;
  }
`;

export const SwitchWrapper = styled.div`
  display: flex;
  gap: ${themeSpacing.xs3};
`;

export const RangeWrapper = styled.div`
  display: flex;
  gap: ${themeSpacing.xs3};
  width: 100%;
`;

export const SelectWrapper = styled.div`
  width: 100%;
`;

export const ToggleText = styled(Text)`
  border-bottom: 1px dashed ${themeColors.textHelper};
`;
